var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j_content step4"},[_c('div',{staticClass:"title"},[_vm._v("회원가입 완료")]),_c('span',[_vm._v(_vm._s(_vm.UserInfo.mb_name))]),_vm._v("님 회원가입을 환영합니다! "),_c('br'),_vm._v(" 관리자 가입승인 후 이용하실 수 있습니다! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }